import React from 'react'
import PieChart from '../diagrams/PieChart';

function LicencesStats(teams) {

    const getLicencesStats = () => {
      return Array.from(
        teams.teams
          .flatMap(team => team.players)
          .reduce((acc, player) => {
            if (player !== undefined) {
            const key = player.licence
              if (key !== "" && key !== undefined) {
                if (!acc.has(key)) {
                  acc.set(key, {
                    label: key,
                    value: 1
                  });
                } else {
                  acc.get(key).value++;
                }
              }
            }
            return acc;
          }, new Map())
        .values()
      ).sort((a, b) => b.value - a.value);
    }
  return (
    <div>
      <PieChart data={getLicencesStats()} />
    </div>
  )
}

export default LicencesStats